import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import overlayStyles from './OverlayHelpers.scss';
const HoverableWrapper = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { isSectionBoundary, className, __forceHoveredForStories } = _param, props = _object_without_properties(_param, [
        "isSectionBoundary",
        "className",
        "__forceHoveredForStories"
    ]);
    const newProps = _object_spread_props(_object_spread({}, props), {
        className: classnames(overlayStyles['hoverable'], __forceHoveredForStories && overlayStyles['force-hovered'], className)
    });
    return isSectionBoundary ? /*#__PURE__*/ React.createElement(Section, _object_spread_props(_object_spread({}, newProps), {
        ref: ref
    })) : /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, newProps), {
        ref: ref
    }));
});
HoverableWrapper.displayName = 'HoverableWrapper';
export default HoverableWrapper;
